import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLiveRefresh } from "@/hooks/useLiveRefresh";

export const HistoricalBookBasis = ({ prefix }) => {
  const [version] = useLiveRefresh();
  const [latest, setLatest] = useState(null), [error, setError] = useState(false);
  useEffect(() => {
    const controller = new AbortController();
    api.get("/portfolio/as-of-dates", { signal: controller.signal }).then(r => { setLatest(r.data.latest); setError(false); })
      .catch(e => { if (e.code !== "ERR_CANCELED") setError(true); });
    return () => controller.abort();
  }, [version]);
  return <p data-testid={`${prefix}-historical-basis`} className="text-xs leading-relaxed text-slate-600 border-y border-slate-200 py-3 mb-4">
    <b>HISTORICAL LMS balances</b> · {error ? "Source date could not be verified." : latest ? `Snapshot ${latest}. Not a current-day portfolio valuation.` : "Verifying snapshot date…"}
  </p>;
};